/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Payment_Validation_Payment_Date_RequiredInputs */

const en_case_payment_validation_payment_date_required = /** @type {(inputs: Case_Payment_Validation_Payment_Date_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter the payment date.`)
};

const pt_br2_case_payment_validation_payment_date_required = /** @type {(inputs: Case_Payment_Validation_Payment_Date_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informe a data do pagamento.`)
};

/**
* | output |
* | --- |
* | "Enter the payment date." |
*
* @param {Case_Payment_Validation_Payment_Date_RequiredInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_payment_validation_payment_date_required = /** @type {((inputs?: Case_Payment_Validation_Payment_Date_RequiredInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Payment_Validation_Payment_Date_RequiredInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_payment_validation_payment_date_required(inputs)
	return pt_br2_case_payment_validation_payment_date_required(inputs)
});